import Link from 'next/link';

import useRoutePaths from '@/src/hooks/useRoutePaths';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, SectionContainer, Text} from '../../../ui';
import css from '../styles/signUpBlock.module.css';

const SignUpBlock = () => {
  const {SIGN_UP_ROUTE} = useRoutePaths();

  return (
    <SectionContainer>
      <div className={css.singInWrapperMob}>
        <Text color={Text.COLOR.GREY} fontSize={Text.FONT_SIZE.SIZE_17}>
          <TextLocal id="sing-in.need-account-q" />
        </Text>
        <div className={css.singInWrapper}>
          <Link href={SIGN_UP_ROUTE.getLink()}>
            <a>
              <Button
                height={Button.HEIGHT.SMALL}
                color={Button.COLOR.SECONDARY}
              >
                <TextLocal id="sing-in.sing-up" />
              </Button>
            </a>
          </Link>
        </div>
      </div>
    </SectionContainer>
  );
};

export default SignUpBlock;
